import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import SettingsControl from '../../Common/SettingsControl/index';
import {
  AuthorityPairTable,
  AuthorityPairTData,
  AuthorityPairTRow,
  AuthorityPairTHead,
  AuthorityPairTBody,
  AuthorityPairTH,
  TableContainer,
} from '../../Common/SharedStyles.styles.js';
import { alertTypeFormatter } from '../../Common/utils';
import { agencyPairStatus } from '../utils';
import OutboundAlertsEmptyState from './OutboundAlertsEmptyState';
import OutboundAlertsNoAlertsAccess from './OutboundAlertsNoAlertsAccess';

const OutboundAlertsTableComponent = ({ linksTo, hasAlertsAccess }) => {
  if (!hasAlertsAccess) {
    return (
      <TableContainer>
        <OutboundAlertsNoAlertsAccess />
      </TableContainer>
    );
  }
  return (
    <TableContainer>
      {linksTo?.length > 0 ? (
        <AuthorityPairTable outbound>
          <AuthorityPairTHead>
            <AuthorityPairTRow>
              <AuthorityPairTH>Name</AuthorityPairTH>
              <AuthorityPairTH>Alert Type</AuthorityPairTH>
              <AuthorityPairTH>Status</AuthorityPairTH>
              <AuthorityPairTH />
            </AuthorityPairTRow>
          </AuthorityPairTHead>
          {linksTo.map(link => (
            <AuthorityPairTBody key={link.id}>
              <AuthorityPairTData overflow="true">
                <Text size="normal" color="secondaryText" ellipsis>
                  {link.link_to.display_name}
                </Text>
              </AuthorityPairTData>
              <AuthorityPairTData>
                <Text size="normal" color="secondaryText">
                  {link.attributes?.alert_emergency_types
                    ?.map(type => alertTypeFormatter(type))
                    .join(', ')}
                </Text>
              </AuthorityPairTData>
              <AuthorityPairTData>
                <Text size="normal" color="secondaryText" ellipsis>
                  {agencyPairStatus(link.status)}
                </Text>
              </AuthorityPairTData>
              <AuthorityPairTData>
                <SettingsControl authority={link} type="outbound" />
              </AuthorityPairTData>
            </AuthorityPairTBody>
          ))}
        </AuthorityPairTable>
      ) : (
        <OutboundAlertsEmptyState />
      )}
    </TableContainer>
  );
};

export default OutboundAlertsTableComponent;
